import * as React from 'react';
import MatchesApi from "../../api/Matches";
import * as moment from 'moment';
import LeaguesApi from "../../api/Leagues";
import TeamsApi from "../../api/Teams";
import PlayersApi from "../../api/Players";
// import Player_TeamApi from "../../api/Player_Team";
import Player_MatchApi from "../../api/Player_Match";
import { toast } from "react-toastify";
import './matches.css';

export default class MatchResult extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            match: {},
            league: {},
            team1: {},
            team2: {},
            team1_players: [],
            team2_players: [],
            players_stats: [],
        };
    }

    componentWillMount(){
        console.log("PROPS")
        console.log(this.props.match.params.value)
        let state = {...this.state};
        MatchesApi.get(this.props.match.params.value).then(r => {
            console.log(r.data.response)
            state.match = r.data.response;
            return LeaguesApi.get(state.match.league1_id);
        }).then(r => {
            state.league = r.data.response;
            return TeamsApi.get(state.match.team1_id);
        }).then(r => {
            state.team1 = r.data.response;
            return TeamsApi.get(state.match.team2_id);
        }).then(r => {
            state.team2 = r.data.response;
            return Player_MatchApi.getByMatch(state.match.id);
        }).then(r => {
            state.players_stats = r.data.response;
            return PlayersApi.getByTeam(state.match.team1_id);
        }).then(r => {
            state.team1_players = r.data.response;
            state.team1_players.forEach(p => {
                let stats = state.players_stats.find(s => s.player_id === p.id);
                p.gp = stats ? stats.played === "1" : false;
                p.bc = stats ? stats.bc : 0;
                p.rc = stats ? stats.rc : 0;
                p.yc = stats ? stats.yc : 0;
                p.goals = stats ? stats.goals : 0;
            });
            return PlayersApi.getByTeam(state.match.team2_id);
        }).then(r => {
            state.team2_players = r.data.response;
            state.team2_players.forEach(p => {
                let stats = state.players_stats.find(s => s.player_id === p.id);
                p.gp = stats ? stats.played === "1" :  false;
                p.bc = stats ? stats.bc : 0;
                p.rc = stats ? stats.rc : 0;
                p.yc = stats ? stats.yc : 0;
                p.goals = stats ? stats.goals : 0;
            });
            this.setState(state);
        }).catch(err => console.log(err));
    }

    saveResult(){
        let promises = [];
        let match = this.state.match;
        match.status = 2;
        this.state.team2_players.forEach(p => {
            let stats = this.state.players_stats.find(s => s.player_id === p.id);
            p.player_id = p.id;
            p.match_id = match.id
            p.status = 1
            p.played = p.gp
            if (stats){
                promises.push(Player_MatchApi.edit(p, stats.id));
            }else{
                promises.push(Player_MatchApi.create(p));
            }
        });
        this.state.team1_players.forEach(p => {
            let stats = this.state.players_stats.find(s => s.player_id === p.id);
            p.player_id = p.id;
            p.match_id = match.id
            p.status = 1
            p.played = p.gp
            if (stats){
                promises.push(Player_MatchApi.edit(p, stats.id));
            }else{
                console.log("entre")
                console.log(p)
                promises.push(Player_MatchApi.create(p));
            }
        });
        promises.push(MatchesApi.edit(match, match.id));

        Promise.all(promises).then (results => {
        }).catch(err => console.log(err));
        toast.success("Resultado actualizado");
    }

    render(){
        return (
            <div>
                <div className="card">
                    <div className="card-content">
                        <div className="columns is-multiline">
                            <div className="column is-6">
                                <h1>Fecha: {moment(this.state.match.day).format("DD/MM/YYYY")}</h1>
                                <h2>Hora: {moment(this.state.match.day).format("H:mm")}</h2>
                            </div>
                            <div className="column is-6">
                                <h1>
                                    Liga: {this.state.match.league1}
                                    {this.state.match.league1!=this.state.match.league2 && "--"+this.state.match.league2}
                                </h1>
                            </div>
                            <div className="column is-4">
                                <div className="FieldHorizontal field is-horizontal">
                                    <div className="field-label">
                                        <label className="label">{this.state.team1.team}</label>
                                    </div>
                                    <div className="field-body">
                                        <input
                                            type="number"
                                            className="input"
                                            autoFocus
                                            min={0}
                                            value={this.state.match.goals1}
                                            onChange={(e) => {
                                                let state = {...this.state};
                                                state.match.goals1 = e.currentTarget.value;
                                                this.setState(state);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="column is-4">
                                <div className="FieldHorizontal field is-horizontal">
                                    <div className="field-label">
                                        <label className="label">{this.state.team2.team}</label>
                                    </div>
                                    <div className="field-body">
                                        <input
                                            type="number"
                                            min={0}
                                            className="input"
                                            value={this.state.match.goals2}
                                            onChange={(e) => {
                                                let state = {...this.state};
                                                state.match.goals2 = e.currentTarget.value;
                                                this.setState(state);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="column is-4">
                                <div className="FieldHorizontal field is-horizontal">
                                    <div className="field-label">
                                        <label className="label">Ganador Shoot Out</label>
                                    </div>
                                    <div className="field-body">
                                        <select className="input"
                                        value={this.state.match.so_win}
                                        onChange={(e) => {
                                            let state = {...this.state};
                                            state.match.so_win = e.currentTarget.value;
                                            this.setState(state);
                                        }}>
                                            <option value="0">Seleccionar</option>
                                            <option  value={this.state.match.team1_id}>{this.state.team1.team}</option>
                                            <option value={this.state.match.team2_id}>{this.state.team2.team}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-content">
                        <div className="columns">
                            <div className="column is-6">
                                <table className="table is-fullwidth players-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Jugador</th>
                                            <th>TA</th>
                                            <th>TAM</th>
                                            <th>TR</th>
                                            <th>G</th>
                                            <th>A</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.team1_players.map(p => {
                                        return (
                                            <tr key={p.id}>
                                                <td>{p.number}</td>
                                                <td>{p.name}</td>
                                                <td><input min={0} value={p.bc} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team1_players.find(player => player.id === p.id);
                                                    player.bc = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input min={0} value={p.yc} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team1_players.find(player => player.id === p.id);
                                                    player.yc = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input min={0} value={p.rc} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team1_players.find(player => player.id === p.id);
                                                    player.rc = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input min={0} value={p.goals} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team1_players.find(player => player.id === p.id);
                                                    player.goals = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input
                                                    id={p.id}
                                                    type="checkbox"
                                                    name="status"
                                                    className="switch"
                                                    checked={p.gp === true}
                                                    onChange={() => {}}
                                                />
                                                    <label className="status" htmlFor="status" onClick={() => {
                                                        let state = {...this.state};
                                                        let player = state.team1_players.find(player => player.id === p.id);
                                                        player.gp = !player.gp;
                                                        this.setState(state);
                                                    }}/></td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            <div className="column is-6">
                                <table className="table is-fullwidth players-table">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Jugador</th>
                                        <th>TA</th>
                                        <th>TAM</th>
                                        <th>TR</th>
                                        <th>G</th>
                                        <th>A</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.team2_players.map(p => {
                                        return (
                                            <tr key={p.id}>
                                                <td>{p.number}</td>
                                                <td>{p.name}</td>
                                                <td><input min={0} value={p.bc} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team2_players.find(player => player.id === p.id);
                                                    player.bc = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input min={0} value={p.yc} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team2_players.find(player => player.id === p.id);
                                                    player.yc = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input min={0} value={p.rc} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team2_players.find(player => player.id === p.id);
                                                    player.rc = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input min={0} value={p.goals} disabled={!p.gp} className="input" type="number" onChange={e => {
                                                    let state = {...this.state};
                                                    let player = state.team2_players.find(player => player.id === p.id);
                                                    player.goals = e.currentTarget.value;
                                                    this.setState(state);
                                                }}/></td>
                                                <td><input
                                                    id={p.id}
                                                    type="checkbox"
                                                    name="status"
                                                    className="switch"
                                                    checked={p.gp === true}
                                                    onChange={() => {}}
                                                />
                                                    <label className="status" htmlFor="status" onClick={() => {
                                                        let state = {...this.state};
                                                        let player = state.team2_players.find(player => player.id === p.id);
                                                        player.gp = !player.gp;
                                                        this.setState(state);
                                                    }}/></td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <button className="button is-success" onClick={() => this.saveResult()}>Guardar resultado</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/matches/matchResult.js